/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable import/no-unresolved */
const txt = require('js/app/core/txt');

// NOTE: we also create a global variable to make the access from templates easier
window.txt = txt;

module.exports = txt;
